/* oxlint-disable @typescript-eslint/no-explicit-any */
import { atom, useAtomValue } from 'jotai';
import { BaseSyntheticEvent, useEffect } from 'react';

import { GeetestCaptchaResponse } from '@flipster/apis/v1/user/types';

interface CaptchaResponse {
  lot_number: string;
  pass_token: string;
  gen_time: string;
  captcha_output: string;
}

export interface Captcha {
  getValidate: () => CaptchaResponse;
  showCaptcha: () => void;
  onSuccess: (callback: () => void) => void;
  onFail: (callback: (failObj: unknown) => void) => void;
  onError: (callback: (error: unknown) => void) => void;
  onClose: (callback: (captchaObj: unknown) => void) => void;
}

export const captchaAtom = atom<Captcha | undefined>(undefined);

interface Params {
  submitFunc: (e?: BaseSyntheticEvent<object>) => Promise<void>;
  setGeetestCaptchaResponse: (value: GeetestCaptchaResponse | null | undefined) => void;
}

export const useCaptcha = ({ submitFunc, setGeetestCaptchaResponse }: Params) => {
  const captcha = useAtomValue(captchaAtom);

  useEffect(() => {
    if (!captcha) return;
    captcha.onSuccess(() => {
      const result = captcha.getValidate();
      if (!result) return;
      setGeetestCaptchaResponse({
        lotNumber: result.lot_number,
        passToken: result.pass_token,
        genTime: result.gen_time,
        captchaOutput: result.captcha_output,
        deviceType: 'WEBSITE',
      });
      submitFunc();
    });
    captcha.onFail(() => {
      setGeetestCaptchaResponse(undefined);
    });
    captcha.onError(() => {
      // captcha에 문제가 있는 경우 각 필드를 ''로 보냄
      // 이 경우 서버에서 captcha에 문제가 있는지 재확인 후 captcha에 문제가 있는 경우 로그인 성공 처리
      setGeetestCaptchaResponse({
        lotNumber: '',
        passToken: '',
        genTime: '',
        captchaOutput: '',
        deviceType: 'WEBSITE',
      });
      submitFunc();
    });
    captcha.onClose(() => {
      setGeetestCaptchaResponse(undefined);
    });
  }, [captcha, setGeetestCaptchaResponse, submitFunc]);
};
